import { lazy } from 'react';
import Gutenberg from './DefaultPack/Gutenberg';

const FAQs = lazy(() => import('../Parts/FAQs'));
const ArtigoDestaque = lazy(() => import('./ArtigoDestaque'));
const Artigos = lazy(() => import('./Artigos'));
const Banner = lazy(() => import('./Banner'));
const BannerContato = lazy(() => import('./BannerContato'));
const BannerServicos = lazy(() => import('./BannerServicos'));
const Historia = lazy(() => import('./Historia'));
const Newsletter = lazy(() => import('./Newsletter'));
const Numeros = lazy(() => import('./Numeros'));
const Parcerias = lazy(() => import('./Parcerias'));
const ProdutosPaginado = lazy(() => import('./ProdutosPaginado'));
const ProdutosSlider = lazy(() => import('./ProdutosSlider'));
const ResumoHistoria = lazy(() => import('./ResumoHistoria'));
const Servicos = lazy(() => import('./Servicos'));
const TextoCustomizado = lazy(() => import('./CustomText'));
const Beneficios = lazy(() => import('./Beneficios'));
const Consorcio = lazy(() => import('./Consorcio'));

interface PropT {
    id: string,
    props?: string
}

const AssemblyComponent = ({ id, props }: PropT) => {
    const processed_props = props ? JSON.parse(props) : [];

    const components: any = {
        "Banner": <Banner />,
        "Benefícios": <Beneficios />,
        "Serviços": <Servicos />,
        "Números": <Numeros />,
        "Artigo - Destaque": <ArtigoDestaque title={"Consórcio"} />,
        "Artigos - 3 itens": <Artigos title="Consórcio" limit={3} />,
        "Artigos": <Artigos limit={6} pagination />,
        "Resumo - História": <ResumoHistoria />,
        "História": <Historia />,
        "Produtos - Slider": <ProdutosSlider />,
        "Produtos - Paginada": <ProdutosPaginado />,
        "Parcerias": <Parcerias />,
        "FAQs": <FAQs />,
        "Consórcio": <Consorcio />,
        "Newsletter": <Newsletter />,
        "Formulário com Banner - Contato": <BannerContato />,
        "Formulário com Banner - Serviços": <BannerServicos />,
        "Formulário com Banner - Trabalhe Conosco": <BannerContato trabalhe_conosco={true} />,
        "Gutenberg": <Gutenberg {...processed_props} />,
        "Texto Customizado": <TextoCustomizado />,
    };

    return components[id] ? components[id] :
        <div style={{ fontSize: 12, background: `rgb(255,150,150)`, margin: "24px auto", padding: 12, textAlign: "center", maxWidth: "90%", width: "1280px" }}>
            Componente <b>{id}</b> não registrado. Edite o arquivo <span style={{ backgroundColor: "#ea6767", padding: "4px 8px", display: "inline-block", borderRadius: 4, border: '1px solid #FFF', fontSize: 12, color: "#FFF", fontStyle: "italic" }}>/src/Components/AssemblyComponent.tsx</span> para adicionar seu componente.
        </div>;
}

export default AssemblyComponent;